    <!-- INDICE -->
    <!-- <app-table-of-content [sections]="sections" (selection)="scrollIntoView($event)"></app-table-of-content> -->
    
    <!-- INTRO CARD -->
    <span #dynamicElement id="intro"></span>
    <app-app-section [sectionInfo]="introSection"></app-app-section>

    <div #guia></div>
    <h1 class="webapp-title">Guía de hospedaje en PDF</h1>
    <div class="movie-header">
        <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/c84658fd-ce8b-44bc-7087-64563992d800/public" alt="" (click)="openPdf()" class="movie-cover">
        <div>
          <div class="movie-block">
              <p>Ahorra tiempo</p>
              <!-- <div class="movie-block-text">Thriller</div> -->
          </div>
          <div class="movie-block">
              <p>Consejos expertos</p>
              <!-- <div class="movie-block-text">1h50</div> -->
          </div>
          <div class="movie-block">
              <p>Comodidad y estilo</p>
              <!-- <div class="movie-block-text">4.2/5</div> -->
          </div>
        </div>
    </div>

    <div #tarifas></div>
    <h1 class="webapp-title">Tarifas</h1>
    <h3 class="medium-gray-title">Precio orientativos, sin gastos mensuales (agua, luz..)</h3>
    <div>
        <table>
            <tr>
            <th class="vj-blue-med">Tipo de Hospedaje</th>
                <th class="vj-blue-med">Precio Min</th>
                <th class="vj-blue-med">Precio Max</th>
            </tr>
            <tr>
                <td>Corta Estancia</td>
                <td>30€/noche</td>
                <td>100€/noche</td>
            </tr>
            <tr>
                <td>Larga Estancia</td>
                <td>400€/mes</td>
                <td>1.500€/mes</td>
            </tr>
        </table>
    </div>

    <!-- APPS PARA BUSCAR -->
    <div #buscar></div>
    <app-section-grid-artists [sectionInfo]="appsBuscar"></app-section-grid-artists>

    <!-- CONSEJOS PARA BUSCAR PISO -->
    <div #tips></div>
    <app-section-checklist [sectionInfo]="consejosBuscar"></app-section-checklist>

    <!-- Button -->
    <button (click)="openLink()" target="_blank" class="button button-fill button-round color-dark">
      Más información
      <!-- <i class="icon f7-icons">videocam_circle</i> -->
    </button>
        
    
    <!-- ESTANCIA CORTA - LARGA -->
    <h2 class="webapp-title-secondary" *ngIf="false">Según el tipo de estancia</h2>
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" *ngIf="false">
        <mat-tab label="Corta">
            <!-- ESTADIAS PARA TURISMO O ESTANCIAS CORTAS -->
            <div class="medium-gray-title">Conociendo la ciudad en pocos días</div>
            <p>Lo más cómodo para conocer el casco histórico y lo más iconico de la ciudad en poco tiempo es hospedarse en el centro. Así estarás a distancias que son cómodas y agradables de caminar, cerca de las principales estaciones de Metro para desplazamientos más lejanos.</p> 
        
            <h2 class="webapp-title-secondary">AirBnb</h2>
            <p>Suele ser la opción más cara y la recomendamos cuando son varias personas las que se van a hospedar, ya que se puede rentar un apartamento completo. Hay que tener cierta precaución con "ofertas demasiado buenas" para ser verdad. Te ayudamos si tienes dudas.</p>
        
            <!-- PAGINAS PARA BUSCAR -->
            <app-section-post-list-img [sectionInfo]="card5"></app-section-post-list-img>
            <p class="my-paragraph justify">En éstas podrás filtrar por precios y utilizar la vista de mapa para saber que tan cerca del centro te encuentras. Son sitios confiables y llevan años en el mercado. Los precios en hostel rondan entre los 13€ y los 30€ por noche. En éstas podrás filtrar por precios y utilizar la vista de mapa para saber que tan cerca del centro te encuentras. Son sitios confiables y llevan años en el mercado. Los precios cambian según el día. Activa alertas y filtros para que te notifiquen cuando el precio es el óptimo para ti.</p>

            <h5 class="webapp-pre-title">Lo más económico de todo...</h5>
            <p>Únicamente es necesario crear una cuenta. Existen reuniones y eventos semanales en ciudades alrededor del mundo donde puedes conocer otros miembros de la comunidad. Experiencias nuevas, realidades distintas.</p>
        </mat-tab>

        <!-- LARGA ESTANCIA -->
        <mat-tab label="Larga">
            <div class="medium-gray-title">Encontrando apartamento en España</div>

            <div class="single-post-content">
                <p>La situación de la vivienda en España es un tema de creciente preocupación y debate. Las ciudades, conocidas por su rica historia, su impresionante arquitectura y su vibrante cultura, han estado lidiando con una compleja crisis inmobiliaria que afecta tanto a los residentes como a los recién llegados. Varios factores clave contribuyen a esta situación.</p>

                <h2 class="webapp-title-secondary">Alta demanda</h2>
                <p>En primer lugar, la alta demanda de vivienda en Barcelona ha hecho subir los precios de las propiedades, lo que hace cada vez más difícil para muchos residentes encontrar viviendas asequibles. La popularidad de la ciudad como destino turístico, combinada con su atractivo para los inversores internacionales, ha provocado un aumento de la especulación inmobiliaria. Muchos propietarios optan por alquilar sus propiedades a turistas a través de plataformas como Airbnb, lo que genera menos opciones de alquiler a largo plazo para los residentes. Como resultado, los precios de los alquileres a largo plazo han aumentado significativamente, dejando fuera a muchos residentes locales y empujándolos a las afueras de la ciudad</p>

                <!-- Photo by <a href="https://unsplash.com/@josedibattista?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Josefina Di Battista</a> on <a href="https://unsplash.com/photos/people-walking-on-sidewalk-near-red-and-brown-building-during-daytime-lQn914ABqWQ?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
                <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/54674890-ff25-4c57-9f35-6762e6031c00/public" alt="">
                <p>La escasez de opciones de vivienda asequible ha provocado un aumento de las situaciones de vida precarias, incluidas condiciones de vida superpobladas y deficientes en algunos barrios. En respuesta, organizaciones comunitarias y activistas han estado abogando por los derechos de los inquilinos y mejores condiciones de vivienda. En los últimos años se han tomado algunas medidas para regular los alquileres a corto plazo y promover opciones de vivienda más estables para los residentes. Sin embargo, el problema persiste y muchos creen que se necesitan políticas más integrales para abordar las causas profundas de la crisis inmobiliaria.Los gobiernos regional y municipal de Barcelona han estado trabajando para implementar medidas que alivien la situación de la vivienda. Estas medidas incluyen el desarrollo de proyectos de viviendas asequibles y regulaciones más estrictas sobre alquileres a corto plazo. Además, el movimiento por el "derecho a la vivienda" ha cobrado impulso, presionando para que se reconozca la vivienda como un derecho humano fundamental y pidiendo mayores protecciones para los inquilinos.</p>
                <p>La situación de la vivienda en Barcelona es un desafío multifacético, arraigado en una combinación de factores, desde la especulación inmobiliaria hasta la falta de opciones de vivienda asequible. Si bien se están haciendo esfuerzos para mejorar la situación, sigue siendo una cuestión apremiante tanto para los residentes como para los responsables políticos de la ciudad. El futuro de la vivienda en Barcelona dependerá de la eficacia de estas medidas y de la capacidad de la ciudad para lograr un equilibrio entre preservar su carácter único y garantizar que la vivienda siga siendo accesible y asequible para todos.</p>
            </div>
            
            <h1 class="single-post-title" *ngIf="false">¿Cómo definir la zona/Barrio?</h1>
            <div class="card" *ngIf="false">
                <div class="card-image">
                <img src="assets/img/cards/2.jpg" alt="" class="card-big-footer-image">
                </div>
                <div class="card-footer card-big-footer">

                <h2>Consejos</h2>
                <div class="flex-col">
                    <a href="https://www.fimiberica.com/Blog/5-recomendaciones-para-alquilar-un-piso-en-Madrid">Tip1</a>
                    <a href="https://www.idealista.com/news/gente/mohawk/blog/10-consejos-encontrar-piso-alquiler-idealista-com">Tip2</a>
                    <a href="https://www.homeserve.es/blog/2017/09/06/check-list-para-descubrir-fallos-antes-de-alquilar-o-comprar">Tip3</a>
                </div>


                <a href="/single/" class="button button-fill button-round color-dark">
                Read More
                <i class="icon f7-icons">arrow_right</i>
                </a>
                </div>
            </div>

        </mat-tab>
    </mat-tab-group>

    <!-- ZONAS Y BARRIOS RECOMENDADOS -->
    <div #zonas></div>
    <h1 class="webapp-title" *ngIf="false">Zonas en cada ciudad</h1>
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" id="barrios" class="of-hidden" *ngIf="false">

        <!-- MADRID -->
        <mat-tab label="Madrid" class="of-hidden">

            <!-- BARRIOS MADRID -->
            <div class="medium-gray-title">Barrios recomendados de Madrid</div>
            <app-section-album-slider [sectionInfo]="barriosMadrid"></app-section-album-slider>

            <!-- ZONAS CARAS -->
            <h2 class="webapp-title-secondary">Zonas más caras</h2>
            <mat-chip-list #chipList aria-label="tag selection"> <!--  (click)="copyContent($event,tag.hashtag)" -->
                <mat-chip *ngFor="let barrio of barriosCarosMadrid"  class="category-slide">
                  {{barrio}}
                </mat-chip>
            </mat-chip-list>

            <h2 class="webapp-title-secondary">Barrios menos recomendados</h2>
            <mat-chip-list #chipList aria-label="tag selection"> <!--  (click)="copyContent($event,tag.hashtag)" -->
                <mat-chip *ngFor="let barrio of barriosPeligrososMadrid"  class="category-slide">
                  {{barrio}}
                </mat-chip>
            </mat-chip-list>

        </mat-tab>

        <mat-tab label="Barcelona">
            <!-- BARRIOS -->
            <div class="medium-gray-title">Barrios recomendados de Barcelona</div>
            <app-section-album-slider [sectionInfo]="barriosBarcelona"></app-section-album-slider>
            
            <!-- ZONAS CARAS -->
            <h2 class="webapp-title-secondary">Zonas más caras</h2>
            <mat-chip-list #chipList aria-label="tag selection"> <!--  (click)="copyContent($event,tag.hashtag)" -->
                <mat-chip *ngFor="let barrio of barriosCarosBarna"  class="link category-slide">
                  {{barrio}}
                </mat-chip>
            </mat-chip-list>

            <h2 class="webapp-title-secondary">Barrios menos recomendados</h2>
            <mat-chip-list #chipList aria-label="tag selection"> <!--  (click)="copyContent($event,tag.hashtag)" -->
                <mat-chip *ngFor="let barrio of barriosPeligrososBarna"  class="link category-slide">
                  {{barrio}}
                </mat-chip>
            </mat-chip-list>

        </mat-tab>

    </mat-tab-group>

    <mat-card  class="smart-card" *ngIf="false">
        <h5>Para postear de búsqueda de piso</h5>
        <ul>
            <li>ciudad</li>
            <li>fechas disponibilidad</li>
            <li>el apartamento incluye</li>
            <li>ubicación</li>
        </ul>
    </mat-card>

    <!-- City Selection Section -->
    <div class="section city-selection" *ngIf="false">
      <h3>Select Your City</h3>
      <div class="btn-group btn-group-toggle" data-toggle="buttons">
        <label class="btn btn-primary shadow-sm" *ngFor="let city of cities" (click)="selectCity(city)">
          <input type="radio" name="options" id="option1" [checked]="selectedCity === city"> {{ city }}
        </label>
      </div>
    </div>
    
    <!-- Accommodation Options Section -->
    <div class="section accommodation-options" *ngIf="selectedCity">
      <h3>Accommodation Options in {{ selectedCity }}</h3>
      <div class="accordion" id="accommodationOptionsAccordion">
        <div class="card shadow-sm" *ngFor="let option of accommodationOptions[selectedCity]">
          <div class="card-header" id="heading{{ option.id }}">
            <h2 class="mb-0">
              <button class="btn btn-link text-dark" type="button" data-toggle="collapse" [attr.data-target]="'#collapse' + option.id" aria-expanded="true" [attr.aria-controls]="'collapse' + option.id">
                {{ option.name }}
              </button>
            </h2>
          </div>
          <div [id]="'collapse' + option.id" class="collapse" [attr.aria-labelledby]="'heading' + option.id" data-parent="#accommodationOptionsAccordion">
            <div class="card-body">
              {{ option.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Post Ad Section -->
    <div class="section post-ad" *ngIf="false">
      <h3>Post an Ad</h3>
      <form (submit)="postAd()">
        <div class="form-group">
          <label for="name">Name</label>
          <input type="text" class="form-control shadow-sm" id="name" [(ngModel)]="adDetails.name" name="name" required>
        </div>
        <div class="form-group">
          <label for="email">Email</label>
          <input type="email" class="form-control shadow-sm" id="email" [(ngModel)]="adDetails.email" name="email" required>
        </div>
        <div class="form-group">
          <label for="city">City</label>
          <select class="form-control shadow-sm" id="city" [(ngModel)]="adDetails.city" name="city" required>
            <option *ngFor="let city of cities">{{ city }}</option>
          </select>
        </div>
        <div class="form-group">
          <label for="description">Description</label>
          <textarea class="form-control shadow-sm" id="description" [(ngModel)]="adDetails.description" name="description" rows="4" required></textarea>
        </div>
        <button type="submit" class="btn btn-primary shadow-sm">Post Ad</button>
      </form>
    </div>
    
    <!-- Best and Worst Areas Section -->
    <div class="section areas" *ngIf="false">
      <h3>Best and Worst Areas to Live in {{ selectedCity }}</h3>
      <div class="row">
        <div class="col-md-6">
          <h4>Best Areas</h4>
          <ul>
            <li *ngFor="let area of bestAreas[selectedCity]">{{ area }}</li>
          </ul>
        </div>
        <div class="col-md-6">
          <h4>Worst Areas</h4>
          <ul>
            <li *ngFor="let area of worstAreas[selectedCity]">{{ area }}</li>
          </ul>
        </div>
      </div>
    </div>
    
<!-- <p>
    ¿Existe la comunicación entre ustedes y el arrendador o únicamente tienen los anuncios entre sus favoritos en Idealista/Badi/SpotaHome...?
Están en comunicación con un arrendador que acepte todas las condiciones de ser estudiantes extranjeras sin contrato laboral, que esté dispuesto a reservar el apartamento desde Costa Rica con las implicaciones del caso ( transferencia internacional, la imposibilidad de firmar el contrato en persona, entre otros).
¿Cuándo quisieran comenzar con las visitas?
Lo preguntamos porque nos preocupa ofrecerles las visitas, y que no puedan sacar valor de ellas, simplemente por las variables que hay en el proceso de cita, visitas y reservación, y la alta demanda y competencia de pisos que hay en Madrid.

El proceso tiene algunas fases, en las cu
Aquí nos preocupan algunos escenarios, por ejemplo:
Aquí nos preocupan algunos escenarios, por ejemplo: Si nosotros lo visitamos en Julio pero el arrendador no puede reservarlo por Julio y Agosto y que entren hasta Septiembre perderíamos esa visita.
Otra opción sería esperar a las últimas 2 semanas antes de llegar aquí a España, pero se cuenta con el riesgo de que alguien más se nos adelante al estar aquí en persona, con el dinero en efectivo, y la documentación física.
Este es un riesgo que sufrimos todos cuando estamos en la fase de cita y reservación por la alta demanda de pisos en Madrid, que probablemente experimenten si optan por el plan de unos días de Airbnb mientras encuentran uno.
Es el arrendador el que les pondrá las condiciones contractuales a las que deberán adaptarse o intentar negociar, por ejemplo:
Documentación exigida
Requerir la firma del contrato en persona de las futuras arrendatarias o sólo la de una de ellas.
Posibilidad de reservar mediante transferencia bancaria internacional
El tiempo de espera entre la reservación y la llegada del dinero desde Costa Rica, entre otras.
Si ya encontraron algún arrendador que acepte todas la condiciones de ser estudiantes extranjeras sin contrato laboral, que esté dispuesto a que reservar el apartamento desde Costa Rica vía email, realizar los pagos vía transferencia, firmar el contrato hasta llegar a España, entre otras variables posibles que el arrendaor
Es el arrendador el que les pondrá las condiciones contractuales a las que deberán adaptarse o intentar negociar, por ejemplo (documentación exigida, requerir la firma del contrato en persona de las futuras arrendatarias o sólo la de una de ellas, posibilidad de reservar mediante transferencia bancaria internacional, el tiempo de espera entre la reservación y la llegada del dinero desde Costa Rica, entre otras).
Por ejemplo cuando reservas para una cita a las 11am, que es lo mejor que has encontrado, sacas el tiempo de ir al piso, y al llegar te notifican que el chico de las 10:30am se lo va a quedar. Eso lo hemos vivido, o bien que te dicen que lo tienes reservado, que traigas la documentación que te piden y hagas la transferencia, pero por lo que sea alguna otra persona ofrece más dinero, en efectivo y en persona, te llaman a decirte que lo sienten mucho pero que han tenido que alquilarlo a otra persona. En esos y en otros bastantes escenarios podría suceder que las visitas que les cobramos no les aporten resultados, esto es por la alta demanda de pisos que hay en Madrid.
ya que estamos entrando en el servicio que ofrecemos a la gente de asistencia avanzada para el hospedaje, que incluye solucionar de forma más personalizada los problemas y dedicarles el tiempo y la atención necesaria.
Por un lado aclararte que
En este tema no podemos alargarnos demasiado ya que al final estamos entrando en terreno de la guía avanzada de hospedaje que es en lo que trabajamos, y ofrecemos con nuestros 3 paquetes, pero por darnos a entender un ejemplo sería:

Para nosotros el proceso de búsqueda de piso a rasgos generales tiene algunas fases, algunas más complicadas que otras.
Búsqueda
Cita
Visita
Reservación
Pagos
  </p> -->